import React from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Helper',
  },
  {
    path: 'Texts',
    breadcrumbName: 'Texts',
  },
];

const Positions = () => {
  return (
    <>

      <PageHeader title="Texts" breadcrumb={{ routes }} subTitle="Align" style={{ padding: 10 }} />

      <div className="MF_area">
        <div className="text_left">text_left</div>
        <div className="text_center">text_center</div>
        <div className="text_right">text_right</div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="text_left">text_left</div>
<div class="text_center">text_center</div>
<div class="text_right">text_right</div>`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>

    </>
  );
}

export default Positions;
